<template>
  <div
    @mousemove="xCoordinate"
    :style="{ backgroundColor: `hsl(${x}, 80%, 50%)` }"
    class="disco-area"
  >
    <h3>Move your mouse across the screen and enjoy the party...</h3>
  </div>
</template>

<script>
export default {
  name: "DiscoArea",
  data() {
    return {
      x: 0,
    };
  },
  methods: {
    xCoordinate(e) {
      this.x = e.clientX;
    },
  },
};
</script>

<style lang="scss" scoped>
.disco-area {
  /*
  for utilizing full screen
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  */
  height: 100vh;
  transition: 0.2s background-color ease;
}
</style>
